export default {
	name: 'bread-crumb',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() { 
        return {
			ecHome: process.env.MAIN_PAGE,
			aptgPage: process.env.APTG_PAGE
        }; 
    },
	computed: {
		breadCrumb() {
			return this.$store.state.breadCrumb;
		}
	},
	watch: {
	},
	created() {},
	mounted() {
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		isActive(index) {
			return index == (this.breadCrumb.length - 1);
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/service/bread-crumb/bread-crumb.js